/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type CartItemCTA_user$ref = any;
type CartItemPricing_user$ref = any;
type CartItemTitle_user$ref = any;
type CartRemoveItemLink_user$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type CartItem_user$ref: FragmentReference;
export type CartItem_user = {|
  +serviceId: ?string,
  +$fragmentRefs: CartRemoveItemLink_user$ref & CartItemPricing_user$ref & CartItemCTA_user$ref & CartItemTitle_user$ref,
  +$refType: CartItem_user$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "CartItem_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "CartRemoveItemLink_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "CartItemPricing_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "CartItemCTA_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "CartItemTitle_user",
      "args": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "serviceId",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'ed51f6af1ea090cb6da403fe8802fc96';
module.exports = node;
